import { customEvent } from "goi_common";
import { useEffect, useState } from "react";

/**
 * 두 번째 CTA (검은색)
 * - 위치: QuoteWhyDifferent 하단 (스크롤 내려서 도달)
 * - 목적지: 메인 CTA와 동일 (/match/request)
 * - 이벤트: btn_cta_bottom (메인 CTA의 btn_cta_quote와 구분)
 */

const MATCH_BASE_URL = "https://www.goifuneral.co.kr/match/request";

function buildCtaHref(originalSearch: string): string {
  const base = `${MATCH_BASE_URL}/`;
  if (!originalSearch || originalSearch === "?") return base;
  return `${base}${originalSearch}`;
}

export const CommonQuoteCtaBottom = () => {
  const [ctaHref, setCtaHref] = useState(`${MATCH_BASE_URL}/`);

  useEffect(() => {
    setCtaHref(buildCtaHref(window.location.search));
  }, []);

  const handleClick = () => {
    customEvent({
      newGtm: {
        path: "funeral_cost_ad",
        trigger_and_target: "btn_cta_bottom",
      },
    });
  };

  return (
    <a
      className="lp-cta lp-cta--black lp-why-cta"
      href={ctaHref}
      onClick={handleClick}
    >
      빈소, 음식 비용 알아보기
      <span className="arrow">→</span>
    </a>
  );
};
